import React, {useContext, useState} from 'react';
import styleCom from "./REGCOM.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import TextArea from "components/TextArea/TextArea";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";
import RadioGroup from "../../components/Radio/RadioGroup";


const RenderHtml = (props) => {
    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [isRolePi, setIsRolePi] = useState(
        (userInfo.roleId === '200001' || userInfo.roleId === '200002')
    );


    let endStudyHtml=<></>;
    const itemOptions = [
         {mapCd: "studyEndStat", value: "1", label: "연구 참여 완료"}
        ,{mapCd: "studyEndStat", value: "2", label: "중도 탈락"}
    ];


    const activeFlagObj = props.activeFlagObj;
    function getOptionList(cdValue) {
        return itemOptions.filter(option => option.mapCd === cdValue);
    }

    const activeEvent = (mapCd, value="") =>{
        /* activeEvent :
         * - 이벤트 발생시 코드와 값을 기준으로 컴포넌트 활성화/비활성화를 제어하는 상태값 변경
         * - 데이터가 존재하는 activeFlag 필드 값을 변경하여 제어( readOlny 같은 옵션에서 값을 참조하는방식)
         */
        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );

        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                }
            });
        }else if(notMatchedObj.length > 0){
            notMatchedObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                props.setDtlValue(item.tarId, '');
            });
        }

    }




    /* Event ****************************************************************************** */
    const [authUserId, setAuthUserId] = useState("");
    const [authUserPw, setAuthUserPw] = useState("");
    //const [isAuthPass, setIsAuthPass] = useState("");

    const btnAuthConfirm = () => {
        if(props.getMstValue('studyEndStat') === '' || props.getMstValue('studyEndStat') === null){
            toast({ type: 'warning', message: '임상연구 종료 항목을 작성하여 주십시오.', opt: { position: "top-center"} });

        }else if(userInfo.lginId != authUserId){
            toast({ type: 'warning', message: '로그인ID / 서명ID 정보가 다릅니다.', opt: { position: "top-center"} });

        }else if(isRolePi===false){
            toast({ type: 'warning', message: '서명은 책임자만 가능합니다.', opt: { position: "top-center"} });
        }else{
            svcGetAuth().then(() => {
                //toast({ type: 'info', message: '저장되었습니다.', opt: { position: "top-center"} });
            });
        }

    }

    /* Call Service ****************************************************************************** */
    async function svcGetAuth() {

        if(props.getMstValue("signatureYn")==="Y"){
            setAuthUserId("");
            setAuthUserPw("");
            toast({ type: 'warning', message: '기존에 서명한 내역이 존재합니다.'});
            return;
        }

        const param = {
            authUserId : authUserId,
            authUserPw : authUserPw
        }
        let result = await postData("/REW/getAuthSignature", param);

        if(result.signatureYn === "Y"){
            //props.updateWorkState(); //상태값 업데이트
            props.setMstValue("signatureId", result.signatureId);
            props.setMstValue("signatureYn", result.signatureYn);
            props.setMstValue("signatureDt", result.signatureDt);
            props.setMstValue("signatureNm", result.signatureNm);
            //toast({ type: 'info', message: '확인이 완료되었습니다.', opt: { position: "top-center"} });
            svcUpdateSignature(result.signatureId, result.signatureYn)

        }else{
            toast({ type: 'warning', message: 'ID/PW 를 확인하여 주십시오.', opt: { position: "top-center"} });
        }

    }

    async function svcUpdateSignature(signId, signYn) {
        let task99Flag = '';
        if(signYn==='Y' && props.getMstValue('studyEndDt') != '' &&props.getMstValue('studyEndStat') != '' ){
            task99Flag = 'C';
        }else{
            task99Flag = 'A';
        }
        props.setMstValue('task99Stat',task99Flag);

        const param = {
            mstId:  props.getMstValue('mstId'),
            signatureId: signId,
            signatureYn: signYn,
            task99Stat: task99Flag
        }

        let result = await postData("/RED/setUpdateSignature", param);
        if(result){
            toast({ type: 'success', message: '서명이 완료되었습니다.', opt: { position: "top-center"} });
        }else{
            toast({ type: 'warning', message: '서명 작업이 실패하였습니다.', opt: { position: "top-center"} });
        }


    }


    /* ****************************************************************************** Event */

    /* [가변형]의료기기 이상반응  ***************************************************************
    * *************************************************************************************** */
//664~674
    const startId = 664; // 원하는 시작값 설정 가능
    const tableCount = 5; // 테이블 개수
    const itemsPerTable = 11; // 각 테이블당 아이템 개수

    // 테이블 목록 생성 (직접 id, value 저장)
    const [tables, setTables] = useState(
        Array.from({ length: tableCount * itemsPerTable }, (_, i) => ({
            tableIndex: Math.floor(i / itemsPerTable) + 1, // 테이블 번호
            id: `M${String(startId + i).padStart(5, "0")}`, // ID 자리수 유지
            value: props.getDtlValue(`M${String(startId + i).padStart(5, "0")}`) || "" // null 처리
        }))
    );

//참조 코드표 테이블 생성 ▲
    //펑션 html 호출 및 제어 +/-버튼
    // - 테이블 갯수와 데이터 확인해서 기본 상태에서는 테이블 1개만 보이도록 하고
    // - 데이터 존재한 만큼 추가표시 후 버튼 이벤트 수행

    const [tableList, setTableList] = useState([{ index: 1 }]);

    const addTable = () => {
        setTableList(prevTables => {
            const newIndex = prevTables.length > 0 ? Math.max(...prevTables.map(t => t.index)) + 1 : 1;
            return [...prevTables, { index: newIndex }];
        });
    };

    const removeTable = (index) => {
        setTableList(prevTables => prevTables.filter(table => table.index !== index));
    };

    /* *************************************************************** [가변형]의료기기 이상반응 */



    endStudyHtml =
        <>
            <div className={styleCom.title_wrap}>
                <h3>임상연구 종료</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom:"10px", padding: "20px"}}>
                <Table variant='default' rowCnt={3} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>임상연구 참여 종료일/중단일</div>
                    <div>
                        <DatePicker selDate={ymdToDate(props.getMstValue('studyEndDt'))} dateFormat={'yyyy-MM-dd'}
                                    onChange={(date) => props.setMstValue('studyEndDt', dateToYMD(date))}/>
                    </div>
                    <div>임상연구 완료여부</div>
                    <div>
                        <RadioGroup options={getOptionList('studyEndStat')}
                                    selectedValue={props.getMstValue('studyEndStat')}
                                    onChange={(val) => props.setMstValue('studyEndStat', val)}/>
                    </div>
                    <div style={{height:"98px"}}>탈락 사유</div>
                    <div>
                        <TextArea width={"300%"} height={"70%"}
                                  value={props.getMstValue('otherDropReason')}
                                  onChange={(val) => props.setMstValue('otherDropReason', val)}
                                  placeholder={"코멘트를 작성해 주세요"} margin={"10px 0 2px auto"}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>연구 책임자 서명</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                본 전자증례기록서에 기록된 모든 내용이 본 임상연구 대상자로부터 정확히 얻어진 결과임을 확인합니다.
                <Table variant='default' rowCnt={2} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>시험책임자 서명 (이름/서명일)
                    </div>
                    <div>
                        {/*<InputUnitText type={"text"} value={props.getMstValue('signatureId')}*/}
                        {/*               maxLength={20} readOnly={true}/>*/}
                        <InputUnitText type={"text"} value={props.getMstValue('signatureNm')}
                                       maxLength={20} readOnly={true}
                                       onChange={(value) => props.setMstValue("signatureNm", value)}/>
                        /
                        <DatePicker selDate={ymdToDate(props.getMstValue('signatureDt'))} dateFormat={'yyyy-MM-dd'}
                                    onChange={(date) => props.setMstValue('signatureDt', dateToYMD(date))}
                                    isDisabled={true}/>
                    </div>
                    <div>서명 권한은 책임자에게만 있습니다.<br/>(ID/PW를 입력 후 확인 버튼을 클릭하세요)

                    </div>
                    <div>
                        ID : <InputUnitText type={"text"} maxLength={20}
                                            value={authUserId} onChange={(value) => setAuthUserId(value)}/>
                        PW : <InputUnitText type={"password"} maxLength={20}
                                            value={authUserPw} onChange={(value) => setAuthUserPw(value)}/>

                        <Button variant="Primary" addStyle={{width: "100px", height: "40px"}}
                                onClick={() => btnAuthConfirm()}
                        >서명(확인)</Button>

                    </div>


                </Table>
            </div>


        </>
    ;


    let renderHtml =
        <></>
    ;

    if (props.contentId === "T4") {
        renderHtml = endStudyHtml;

    } else {
        renderHtml = <>준비중 입니다.</>;
    }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

